module.exports = __webpack_public_path__ + "img/hip-ecto-mesomorph-male.a2b2860c.svg";